export default __webpack_public_path__ + "static/media/calendarIcon.9107b452.svg";